import { ChangeDetectionStrategy, Component, inject, output, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { materialModules } from './../../../core/constants/mat-modules';
import { OpeningHoursComponent } from '../opening-hours/opening-hours.component';
import { PortalDataService } from '../portal-data.service';
import { TranslatePipe } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'madero-welcome',
    templateUrl: './welcome.component.html',
    styleUrl: './welcome.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [...materialModules, OpeningHoursComponent, TranslatePipe]
})
export class WelcomeComponent {
  readonly portalDataService = inject(PortalDataService);
  readonly #route = inject(ActivatedRoute);
  readonly #snackBar = inject(MatSnackBar);

  joinWaitingList = output<void>();
  showOpeningHours = signal(false);

  get branch() {
    return this.portalDataService.branch()!;
  }

  get storeName(): string | null {
    return this.#route.snapshot.queryParamMap.get('store');
  }

  get isJeronimo(): boolean {
    return this.storeName?.toLowerCase() === 'jeronimo';
  }

  onBindOpeningHours(): void {
    this.showOpeningHours.set(true);
    this.portalDataService.bindBranchDetails();
  }

  onViewMenu(): void {
    const stores = this.branch.stores;

    if (!stores || stores.length === 0) {
      this.#snackBar.open('Cardápio não disponível no momento', 'Fechar', {
        verticalPosition: 'top',
        duration: 5000,
      });
      return;
    }

    const selectedStore = this.getSelectedStore(stores);

    if (selectedStore?.storeMenus && selectedStore.storeMenus.length > 0) {
      const ptMenu =
        selectedStore.storeMenus.find((m: any) => m.languageCode.toLowerCase() === 'pt') ||
        selectedStore.storeMenus[0];
      window.open(ptMenu.url, '_blank');
    }
  }

  private getSelectedStore(stores: any[]) {
    if (!this.storeName || stores.length === 1) {
      return stores[0];
    }

    return stores.find((s) => s.brandName.toLowerCase() === this.storeName!.toLowerCase()) || stores[0];
  }
}
